import { c as _c } from "react/compiler-runtime";
import { useId, ReactNode } from 'react';
import classNames from 'classnames';
import { Radio } from '@udemy-v2/react-form-components';
import styles from './collapsible-purchase-section.module.scss';
export interface CollapsiblePurchaseSectionProps {
  title: ReactNode;
  children: ReactNode;
  expanded?: boolean;
  showRadio?: boolean;
  /** When true, renders a static header (GR-87 marketplace-only price box). */
  disableToggle?: boolean;
  onExpand?: () => void;
}
export const CollapsiblePurchaseSection = t0 => {
  const $ = _c(29);
  const {
    title,
    children,
    expanded: t1,
    showRadio: t2,
    disableToggle: t3,
    onExpand
  } = t0;
  const expanded = t1 === undefined ? false : t1;
  const showRadio = t2 === undefined ? true : t2;
  const disableToggle = t3 === undefined ? false : t3;
  const contentId = useId();
  let t4;
  if ($[0] !== expanded || $[1] !== onExpand) {
    t4 = () => {
      if (!expanded) {
        onExpand?.();
      }
    };
    $[0] = expanded;
    $[1] = onExpand;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const handleClick = t4;
  let t5;
  if ($[3] !== expanded || $[4] !== showRadio) {
    t5 = showRadio && <div className={styles.radio}><Radio size="large" checked={expanded} readOnly={true} /></div>;
    $[3] = expanded;
    $[4] = showRadio;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== title) {
    t6 = <div className={styles["radio-controlled-title"]}>{title}</div>;
    $[6] = title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <div className={styles["radio-controlled-title-wrapper"]}>{t5}{t6}</div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const titleContent = t7;
  let t8;
  if ($[11] !== contentId || $[12] !== disableToggle || $[13] !== expanded || $[14] !== handleClick || $[15] !== titleContent) {
    t8 = disableToggle ? <div className={classNames(styles["panel-toggler"], styles["panel-toggler-static"])}>{titleContent}</div> : <button type="button" aria-expanded={expanded} aria-controls={contentId} onClick={handleClick} className={styles["panel-toggler"]}>{titleContent}</button>;
    $[11] = contentId;
    $[12] = disableToggle;
    $[13] = expanded;
    $[14] = handleClick;
    $[15] = titleContent;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = !expanded;
  const t10 = !expanded;
  let t11;
  if ($[17] !== t10) {
    t11 = classNames({
      [styles["panel-content-collapsed"]]: t10
    });
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== children) {
    t12 = <div className={styles["radio-controlled-content"]}>{children}</div>;
    $[19] = children;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== contentId || $[22] !== t11 || $[23] !== t12 || $[24] !== t9) {
    t13 = <div id={contentId} role="group" aria-hidden={t9} className={t11}>{t12}</div>;
    $[21] = contentId;
    $[22] = t11;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t8) {
    t14 = <div className={styles.panel}>{t8}{t13}</div>;
    $[26] = t13;
    $[27] = t8;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
};